import React, { useContext, useRef, useState } from "react";
import { ALERT_TYPE, CUENTA_STATE, MASK_FORMAT, OPERATION_MODE, PROCESO_STATE, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import { APIS } from "../../config/apis";
import { ServerRequest } from "../../utils/apiweb";
import { useNav, useFilterPersistence, useNavigateWithFilters } from "../../components/hooks";
import {
    Loading,
    TableCustom,
    SectionHeading,
    WrapperAdvancedSearch,
} from "../../components/common";
import DataTaggerModalApi from "../../components/controls/DataTaggerModalApi";
import { MESSAGE_MODALS } from "../../context/custom/MessageModalContext";
import { ManagedContext } from "../../context/custom";
import {usePermissions} from "../../components/hooks/usePermissions";
import {PERMISSIONS} from "../../consts/permissions";
import {TIPS} from "../../consts/tips";

function EmisionEjecucionesView() {
    const navigate = useNav();
    const { showMessageModal } = useContext(ManagedContext);

    const { hasPermission } = usePermissions();
    const canEdit = hasPermission(PERMISSIONS.EMISION_EDIT);

    const [state, setState] = useState({
        loading: false,
        dataTagger: {
            showModal: false,
            idEntidad: null,
        },
        list: [],
    });

    const [tableVisible, setTableVisible] = useState(false);

    const searchRef = useRef();
    const tableRef = useRef();

    const SearchEmisionEjecucionesWithSavedFilters = () => {
        if (searchRef.current) {
            SearchEmisionEjecuciones();
        }
    };

    const { getCurrentFilters, restoredPageIndex, restoredGlobalFilter } = useFilterPersistence(
        searchRef,
        tableRef,
        SearchEmisionEjecucionesWithSavedFilters
    );

    const navigateWithFilters = useNavigateWithFilters(getCurrentFilters);

    // function showEmisionEjecucionModify(row) {
    //     return (
    //         row.idEstadoProcesoCuentaCorriente !== PROCESO_STATE.FINALIZADO ||
    //         (row.imprimeRecibosEmision &&
    //             (row.idEstadoProcesoPublicacionDeuda !== PROCESO_STATE.FINALIZADO ||
    //                 row.idEstadoProcesoImpresion !== PROCESO_STATE.FINALIZADO))
    //     );
    // }

    const handleClickEmisionEjecucionAdd = () => {
        navigateWithFilters(`/emision-ejecucion/${OPERATION_MODE.NEW}`);
    };

    const handleClickEmisionEjecucionView = (id) => {
        navigateWithFilters(`/emision-ejecucion/${OPERATION_MODE.VIEW}/${id}`);
    };

    const handleClickEmisionEjecucionModify = (id) => {
        navigateWithFilters(`/emision-ejecucion/${OPERATION_MODE.EDIT}/${id}`);
    };

    const handleClickEmisionEjecucionRemove = (id) => {
        const ejecucion = state.list.find((x) => x.id === id);
        showMessageModal({
            ...MESSAGE_MODALS.BORRAR,
            message: `¿Está seguro de borrar la ejecución ${ejecucion.numeroEmisionEjecucion}?`,
            onConfirm: () => RemoveEmisionEjecucion(id),
        });
    };

    const handleClickEmisionEjecucionDataTagger = (id) => {
        setState((prevState) => ({
            ...prevState,
            dataTagger: { showModal: true, idEntidad: id },
        }));
    };

    function RemoveEmisionEjecucion(id) {
        setState((prevState) => ({ ...prevState, loading: true }));

        const callbackSuccess = (response) => {
            response
                .json()
                .then(() => {
                    setState((prevState) => ({ ...prevState, loading: false }));
                    SearchEmisionEjecuciones();
                })
                .catch((error) => {
                    ShowToastMessage(
                        ALERT_TYPE.ALERT_ERROR,
                        "Error procesando respuesta: " + error
                    );
                    setState((prevState) => ({ ...prevState, loading: false }));
                });
        };

        const paramsUrl = `/${id}`;

        ServerRequest(
            REQUEST_METHOD.DELETE,
            null,
            true,
            APIS.URLS.EMISION_EJECUCION,
            paramsUrl,
            null,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );
    }

    const callbackNoSuccess = (response) => {
        response
            .json()
            .then((error) => {
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error.message);
                setState((prevState) => ({ ...prevState, loading: false }));
            })
            .catch((error) => {
                ShowToastMessage(
                    ALERT_TYPE.ALERT_ERROR,
                    "Error procesando respuesta: " + error
                );
                setState((prevState) => ({ ...prevState, loading: false }));
            });
    };

    const callbackError = (error) => {
        ShowToastMessage(
            ALERT_TYPE.ALERT_ERROR,
            "Error procesando solicitud: " + error.message
        );
        setState((prevState) => ({ ...prevState, loading: false }));
    };

    function SearchEmisionEjecuciones() {
        setState((prevState) => ({ ...prevState, loading: true, list: [] }));

        const {
            idTipoTributo,
            idEmisionDefinicion,
            numero,
            descripcion,
            periodo,
            etiqueta,
            calculoMostradorWebFinalizada,
            calculoMostradorWebPendiente,
        } = searchRef.current?.filters || {};

        const callbackSuccess = (response) => {
            response
                .json()
                .then((data) => {
                    const list = data.filter(
                        (f) =>
                            f.calculoMasivo ||
                            (calculoMostradorWebFinalizada &&
                                f.idEstadoProcesoCuentaCorriente === PROCESO_STATE.FINALIZADO) ||
                            (calculoMostradorWebPendiente &&
                                f.idEstadoProcesoCuentaCorriente !== PROCESO_STATE.FINALIZADO)
                    );
                    setState((prevState) => ({
                        ...prevState,
                        loading: false,
                        list,
                    }));
                    setTableVisible(true);
                })
                .catch((error) => {
                    ShowToastMessage(
                        ALERT_TYPE.ALERT_ERROR,
                        "Error procesando respuesta: " + error
                    );
                    setState((prevState) => ({ ...prevState, loading: false }));
                });
        };

        const soloCalculoMasivo =
            !calculoMostradorWebFinalizada && !calculoMostradorWebPendiente;
        const paramsUrl =
            `/filter?` +
            `idTipoTributo=${idTipoTributo || 0}&` +
            `idEmisionDefinicion=${idEmisionDefinicion || 0}&` +
            `numero=${encodeURIComponent(numero || "")}&` +
            `descripcion=${encodeURIComponent(descripcion || "")}&` +
            `periodo=${encodeURIComponent(periodo || "")}&` +
            `etiqueta=${encodeURIComponent(etiqueta || "")}&` +
            `calculoMasivo=${soloCalculoMasivo ? "1" : "0"}&` +
            `calculoMostradorWebFinalizada=0`;

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.EMISION_EJECUCION,
            paramsUrl,
            null,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );
    }

    const onSearch = () => {
        SearchEmisionEjecuciones();
    };

    const cellA = () => !canEdit ? '' : (
        <div className='action'>
            <div onClick={() => handleClickEmisionEjecucionAdd()} className="link">
                <span className="material-symbols-outlined" title="Nuevo">add</span>
            </div>
        </div>
    );

    const cellVMR = (props) => (
        <div className="action">
            <div onClick={() => handleClickEmisionEjecucionView(props.value)} className="link">
                <span className="material-symbols-outlined" title="Ver">
                search
                </span>
            </div>
            {canEdit && (
                <>
                    <div onClick={() => handleClickEmisionEjecucionModify(props.value)} className="link">
                        <span className="material-symbols-outlined" title="Modificar">
                            stylus
                        </span>
                    </div>
                    <div onClick={() => handleClickEmisionEjecucionRemove(props.value)} className="link">
                        <span className="material-symbols-outlined" title="Eliminar">
                        delete
                        </span>
                    </div>
                </>
            )}
            <div onClick={() => handleClickEmisionEjecucionDataTagger(props.value)} className="link">
                <span className="material-symbols-outlined" title="Información adicional">
                info
                </span>
            </div>
        </div>
    );

    const tableColumns = [
        { Header: "Tipo de tributo", accessor: "tipoTributo", width: "10%" },
        { Header: "Numeración", accessor: "numeracion", width: "12%" },
        { Header: "N° Definición", accessor: "numeroEmisionDefinicion", width: "9%" },
        { Header: "N° Ejecución", accessor: "numeroEmisionEjecucion", width: "9%" },
        { Header: "Descripción", accessor: "descripcionEmisionEjecucion", width: "26%" },
        { Header: "Período", accessor: "periodo", width: "6%" },
        { Header: "Estado", accessor: "estadoEmisionEjecucion", width: "8%" },
        { Header: "Aprobación", accessor: "estadoEmisionAprobacion", width: "10%" },
        {
            Header: cellA,
            Cell: cellVMR,
            id: "abm",
            accessor: "id",
            width: "10%",
            disableGlobalFilter: true,
            disableSortBy: true,
        },
    ];

    const dataTaggerRegistro = state.list.find(x => x.id === state.dataTagger.idEntidad)?.descripcionEmisionEjecucion ?? ''

    return (
        <>
            <Loading visible={state.loading} />

            {state.dataTagger.showModal && (
                <DataTaggerModalApi
                    title="Información adicional de Ejecución de Emisiones"
                    registro={dataTaggerRegistro}
                    tipName={TIPS.NAME.MODALS.INFORMACION_ADICIONAL_EMISION_EJECUCIONES_MODAL}
                    entidad="EmisionEjecucion"
                    idEntidad={state.dataTagger.idEntidad}
                    disabled={state.dataTagger.disabled}
                    onConfirm={() => {
                        setState((prevState) => ({
                            ...prevState,
                            dataTagger: { showModal: false, idEntidad: null },
                        }));
                    }}
                    onDismiss={() => {
                        setState((prevState) => ({
                            ...prevState,
                            dataTagger: { showModal: false, idEntidad: null },
                        }));
                    }}
                />
            )}

            <SectionHeading
                titles={[{ title: "Emisión" }, { title: "Ejecución de emisiones" }]}
                onAddClick={canEdit ? handleClickEmisionEjecucionAdd : null}
                tableVisible={tableVisible}
            />

            <section className="section-accordion">
                <WrapperAdvancedSearch
                    ref={searchRef}
                    filters={[
                        {
                            title: "Tipo de tributo",
                            field: "idTipoTributo",
                            type: "list",
                            lista: "TipoTributo",
                            size: 3,
                        },
                        {
                            title: "Número definición",
                            field: "idEmisionDefinicion",
                            tipName: TIPS.NAME.MODALS.EMISION_DEFINICION_MODAL,
                            type: "entity",
                            entidad: "EmisionDefinicion",
                            size: 3,
                            onFormat: (row) => (row && row.id ? row.numero : ""),
                            onLabelFormat: (row) => row?.numero ?? "",
                            columns: [
                                { Header: "Número", accessor: "numero", width: "20%" },
                                { Header: "Descripción", accessor: "descripcion", width: "80%" },
                            ],
                        },
                        {
                            title: "Número ejecución",
                            field: "numero",
                            type: "string",
                            size: 2,
                            mask: MASK_FORMAT.EMISION_NUMERO,
                            searchOnEnter: true,
                        },
                        {
                            title: "Período",
                            field: "periodo",
                            type: "string",
                            size: 2,
                            searchOnEnter: true,
                        },
                        {
                            title: "Etiqueta",
                            field: "etiqueta",
                            type: "string",
                            size: 2,
                            searchOnEnter: true,
                        },
                        {
                            title: "Descripción",
                            field: "descripcion",
                            type: "string",
                            size: 6,
                            searchOnEnter: true,
                        },
                        {
                            title: "Incluir liquidaciones web finalizadas",
                            field: "calculoMostradorWebFinalizada",
                            type: "boolean",
                            size: 3,
                        },
                        {
                            title: "Incluir liquidaciones web pendientes",
                            field: "calculoMostradorWebPendiente",
                            type: "boolean",
                            size: 3,
                        },
                    ]}
                    onSearch={onSearch}
                />

                {tableVisible && (
                    <TableCustom
                        ref={tableRef}
                        restoredPageIndex={restoredPageIndex}
                        defaultGlobalFilter={restoredGlobalFilter}
                        className={"TableCustomBase m-top-20"}
                        columns={tableColumns}
                        data={state.list}
                        messageEmpty="No se encontraron resultados"
                    />
                )}
            </section>
        </>
    );
}

export default EmisionEjecucionesView;
